import { gql } from "lib/apolloClient";

export const getStaffListQuery = gql`
  query getStaffList($organizationId: ID!, $filters: OrgConnectionFilterInput) {
    node(id: $organizationId, type: ORGANIZATION) {
      ... on Organization {
        id
        staff(filters: $filters) {
          totalCount
          edges {
            node {
              id
              firstName
              lastName
              middleName
              isArchived
              preferredName
              prefix
              suffix
              pronouns
              type
            }
          }
        }
      }
    }
  }
`;
